"use client";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import SkillsSection from "@/components/SkillsSection";
import ProjectsSection from "@/components/ProjectsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-white dark:bg-[#020817]">
      {/* Main Content - All animations and backgrounds removed for performance */}
      <div className="flex flex-col min-h-screen w-full">
        <main className="relative w-full max-w-full">
          <section className="min-h-screen w-full">
            <HeroSection />
          </section>
          <section className="w-full px-4 sm:px-6 lg:px-8">
            <AboutSection />
          </section>
          <section className="w-full px-4 sm:px-6 lg:px-8">
            <SkillsSection />
          </section>
          <section className="w-full px-4 sm:px-6 lg:px-8">
            <ProjectsSection />
          </section>
          <section className="w-full px-4 sm:px-6 lg:px-8">
            <ContactSection />
          </section>
        </main>
      </div>
    </div>
  );
}
